/**
 * @Author: zangkang
 * @Date:   2018-02-25T21:13:18+08:00
 * @Last modified by:   zangkang
 * @Last modified time: 2018-02-25T21:13:18+08:00
 */

import _util from '../../utils/';

const annualLeaveListService = {
	// fetchAnnualLeaveList (params, resolve, reject) {
    //     _util.request({
    //         url: '/api/HRAnnualLeave/Get',
    //         params: params,
    //         success: resolve,
    //         error: reject
    //     })
    // },
    fetchAnnualLeaveList (params, resolve, reject) {
        _util.request({
            url: '/api/HRAnnualVacation/Get',
            params: params,
            success: resolve,
            error: reject
        })
	},
	exportAnnualLeaveList (params, resolve, reject){

        _util.request({
            url: '/api/HRAnnualLeave/Export',
            params: params,
            success: resolve,
            error: reject
        })
		
	},
	// updateAnnualLeave (data, resolve, reject) {
    // 	_util.request({
    //         url: '/api/HRAnnualLeave/Put',
    //         method: 'PUT',
    //         data: data,
    //         success: resolve,
    //         error: reject
    //     })
    // },

    updateAnnualLeave (data, resolve, reject) {
    	_util.request({
            url: '/api/HRAnnualVacation/Put',
            method: 'PUT',
            data: data,
            success: resolve,
            error: reject
        })
    },
    reCaculate(resolve, reject) {
        _util.request({
            url: '/api/HRAnnualLeave/Recalculate',
            method: 'post',
            // data: data,
            success: resolve,
            error: reject
        })        
    }
}

export default annualLeaveListService;


// WEBPACK FOOTER //
// ./src/services/Attendance/annual-leave-service.js